// M21: short Guatemalan Spanish lines for the ads (the humour picker in the ad form fills the headline with one;
// the headline stays editable). Owner rules: usted when a line speaks to the customer; nothing offensive,
// sexual or political. M21b: every line is tagged — 'general' suits any food (café, pizza, sushi, bakery,
// juice bar …), 'fast' is for burgers and fast food — and the picker lists the general lines first. Edit this
// list to change what the picker offers.
export type HumourTag = 'general' | 'fast';
export type HumourLine = { text: string; tag: HumourTag };

export const HUMOUR_LINES: HumourLine[] = [
  { text: 'Su dieta puede esperar. Esta no.', tag: 'general' },
  { text: '¡A la gran, qué hambre!', tag: 'general' },
  { text: '¿Hambre? Aquí se le quita.', tag: 'general' },
  { text: 'El lunes empieza la dieta. Hoy no es lunes.', tag: 'general' },
  { text: 'Pida dos. Uno es para compartir… o no.', tag: 'general' },
  { text: 'Esto está al chilazo.', tag: 'general' },
  { text: 'Va de una: pídalo ya.', tag: 'general' },
  { text: 'Rico, y no le cuesta tanto pisto.', tag: 'general' },
  { text: 'Más sabroso que el fiambre de noviembre.', tag: 'general' },
  { text: 'Puro sabor, cero pena.', tag: 'general' },
  { text: 'Ni modo, hoy toca darse gusto.', tag: 'general' },
  { text: 'Hecho con cariño y bastante queso.', tag: 'fast' },
  { text: 'Si lo ve, se le antoja. Si lo prueba, regresa.', tag: 'general' },
  { text: 'Primero se come, después se platica.', tag: 'general' },
  { text: 'Su estómago se lo va a agradecer.', tag: 'general' },
  { text: 'Cuidado: puede causar sonrisas.', tag: 'general' },
  { text: 'Hoy no cocine usted. Cocinamos nosotros.', tag: 'general' },
  { text: 'Recién salido de la plancha.', tag: 'fast' },
  { text: 'Tan bueno que no va a querer compartir.', tag: 'general' },
  { text: '¿Ya almorzó? Nosotros le resolvemos.', tag: 'general' },
  { text: 'De que se antoja, se antoja.', tag: 'general' },
  { text: 'Póngale sabor a su día.', tag: 'general' },
  { text: 'Una mordida y ya no para.', tag: 'general' },
  { text: 'Grande como su antojo.', tag: 'general' },
  { text: 'Aquí nadie se queda con hambre.', tag: 'general' },
  // M21b: 15 more, including generic alternatives to the burger-specific template defaults.
  { text: 'Más grande de lo que se imagina.', tag: 'general' },
  { text: '¿Este o aquel? ¿Por qué no los dos?', tag: 'general' },
  { text: '¿Qué espera? ¡Pídame!', tag: 'general' },
  { text: 'Hora de comer.', tag: 'general' },
  { text: 'Últimas horas.', tag: 'general' },
  { text: 'Lo encuentra aquí.', tag: 'general' },
  { text: 'Pequeño pecado. Gran sabor.', tag: 'general' },
  { text: 'Por dentro, aún mejor.', tag: 'general' },
  { text: 'Para chuparse los dedos.', tag: 'general' },
  { text: 'Hecho al momento, como debe ser.', tag: 'general' },
  { text: 'Antojo resuelto.', tag: 'general' },
  { text: 'Más grande que su celular.', tag: 'fast' },
  { text: '¿Pollo o carne? ¿Por qué no los dos?', tag: 'fast' },
  { text: 'Con doble queso, como debe ser.', tag: 'fast' },
  { text: 'Papas incluidas, sonrisa también.', tag: 'fast' },
];

/** The picker's order: the general lines first, then burgers and fast food. */
export const HUMOUR_GROUPS: { tag: HumourTag; lines: string[] }[] = (['general', 'fast'] as const).map(
  (tag) => ({ tag, lines: HUMOUR_LINES.filter((l) => l.tag === tag).map((l) => l.text) }),
);
